import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query'
import {
  getUnpaidShifts,
  GetUnpaidShiftsOptions,
  GetUnpaidShiftsResponse,
} from 'api/unpaidShifts'

/**
 * Get a list of unpaid shifts that match the given filters
 * @example useUnpaidShifts({ userId: 123, status: ['approved'] }, { retry: true })
 */
export function useUnpaidShifts(
  /** Pass through to API */
  filters: GetUnpaidShiftsOptions,
  /** useQuery options */
  options?: Pick<
    Parameters<
      typeof useQuery<
        GetUnpaidShiftsResponse,
        Error,
        GetUnpaidShiftsResponse,
        string[]
      >
    >[0],
    'retry' | 'initialData' | 'enabled' | 'placeholderData'
  >
): UseQueryResult<GetUnpaidShiftsResponse> {
  return useQuery({
    queryKey: ['unpaidShifts', filters as any],
    queryFn: async () => getUnpaidShifts(filters),
    retry: false,
    placeholderData: keepPreviousData,
    ...options,
  })
}
